import { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    IconButton,
    Box,
} from "@mui/material";
import { CloseOutlined, ChecklistOutlined } from "@mui/icons-material";
import CheckCircle from "@mui/icons-material/CheckCircle";

import { useRegisterUser } from "../../hooks/authHooks";
import RegistrationForm from "../forms/RegistrationForm";


const RegisterPopup = ({ open, onClose, onLogin }) => {

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const {
        mutate: registerUser,
        isPending: isRegistering,
        error: registerError,
        data: registerData,
    } = useRegisterUser();

    const handleSubmit = (values) => {
        const formData = {
            name: values.fullName,
            email: values.email,
            password: values.password,
            confirm_password: values.confirmPassword,
            tc: values.acceptTC,
        };
        registerUser(formData);
    };

    // Handle side effects from registration success
    useEffect(() => {
        if (registerData) {
            // Handle successful registration
            setSuccessMessage("Registration successful. Please check your email to verify your account.");
            setErrorMessage("");
        }
    }, [registerData]);

    useEffect(() => {
        if (registerError) {
            setSuccessMessage("");
            setErrorMessage("Registration failed. Please try again later.");
        }
    }, [registerError]);

    return (
        <Dialog open={true} maxWidth="sm" fullWidth>
            {/* DIALOG TITLE */}
            <DialogTitle>
                Register
                <IconButton
                    area-label="Close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    disabled={isRegistering}
                >
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>

            {successMessage && (
                <DialogContent>
                    <Box
                        variant="body2"
                        sx={{
                            mb: 2,
                            display: 'flex',
                            fontWeight: 500,  // Make the text a little bolder
                            color: 'text.primary',  // Ensure the text color matches the theme
                        }}
                    >
                        <CheckCircle
                            sx={{
                                mr: 1,  // Space between the icon and text
                                fontSize: '1.25rem',  // Icon size
                                color: 'success.main',  // Success color for the icon
                            }}
                        />
                        <Typography>
                            {successMessage}
                        </Typography>
                    </Box>
                </DialogContent>
            )}

            {/* DIALOG CONTENT */}
            {!successMessage && (
                <>
                    {registerError && (
                        <DialogContent>
                            <Typography variant="body1" color="error">
                                {errorMessage}
                            </Typography>
                        </DialogContent>
                    )}
                    <DialogContent >
                        <RegistrationForm
                            isRegistering={isRegistering}
                            onLogin={onLogin}
                            onSubmit={handleSubmit}
                            onClose={onClose}
                        />
                    </DialogContent>
                </>
            )
            }
        </Dialog>
    );

};


export default RegisterPopup;